export default __webpack_public_path__ + "ca5cd6eb4fc5bd606318d31a171eb4aa.png";